"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'smartFarming.title',
        defaultMessage: 'Smart farming',
        description: 'Smart farming title',
    },
    description: {
        id: 'smartFarming.description',
        defaultMessage: 'Choose your connected Brand Portal',
        description: 'Smart farming description',
    },
    // SHOULD BE REMOVED
    description2: {
        id: 'smartFarming.description2',
        defaultMessage: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam-',
        description: 'Smart farming description 2',
    },
    details: {
        id: 'smartFarming.details',
        defaultMessage: "A lot of data is generated on your farm. Valuable data for your documentation and as a decision-making basis for optimizing machinery, personnel and operating resources. The complete recording and visualization of data is essential for this. You will reach your limits with pen and paper. With {appNameConcatenation}, planning and documentation is child's play. Your fleet has standardized field data records and task reports flow wirelessly into your portal. A simple and intuitive introduction to digital documentation and machine operation that saves time and resources.",
        description: 'Smart farming details message',
    },
    comma: {
        id: 'smartFarming.details.comma',
        defaultMessage: ', ',
        description: 'comma for details if there are more than 2 apps',
    },
    and: {
        id: 'smartFarming.details.and',
        defaultMessage: ' and ',
        description: 'and for details if there are 2 apps',
    },
    appNameValtra: {
        id: 'smartFarming.details.appNames.valtra',
        defaultMessage: 'Valtra Connect Pro',
        description: 'Name of the Valtra app',
    },
    appNameFendt: {
        id: 'smartFarming.details.appNames.fendt',
        defaultMessage: 'FendtONE offboard',
        description: 'Name of the Fendt app',
    },
    appNameMassey: {
        id: 'smartFarming.details.appNames.massey',
        defaultMessage: 'MF Farm Connect',
        description: 'Name of the Massey app',
    },
});
exports.default = messages;
